/**
 * MobilePageHeader - Header for mobile pages with back button
 * Shows page title and back navigation
 */

import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowLeft, Home } from 'lucide-react';
import { cn } from '../lib/utils';

const MobilePageHeader = ({ 
    title, 
    subtitle,
    icon: Icon,
    backPath = '/dashboard',
    showBackButton = true,
    className = '',
    rightContent,
    darkMode = false
}) => {
    const navigate = useNavigate();
    
    // Only show on mobile
    return (
        <div className={cn(
            "md:hidden sticky top-0 z-40 backdrop-blur-xl border-b -mx-4 px-4 py-3 mb-4",
            "safe-area-top",
            darkMode 
                ? "bg-gray-900/95 border-gray-700" 
                : "bg-white/95 border-zinc-200",
            className
        )} data-testid="mobile-page-header">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    {showBackButton && (
                        <Button
                            variant="ghost"
                            size="icon"
                            onClick={() => navigate(backPath)}
                            className={cn(
                                "h-10 w-10 rounded-xl touch-target",
                                darkMode 
                                    ? "bg-gray-800 hover:bg-gray-700 text-white" 
                                    : "bg-zinc-100 hover:bg-zinc-200"
                            )}
                            data-testid="mobile-back-btn"
                        >
                            <ArrowLeft className={cn("w-5 h-5", darkMode ? "text-white" : "text-zinc-700")} />
                        </Button>
                    )}
                    <div className="flex items-center gap-2">
                        {Icon && (
                            <div className={cn(
                                "w-8 h-8 rounded-lg flex items-center justify-center",
                                darkMode ? "bg-orange-500/20" : "bg-primary/10"
                            )}>
                                <Icon className={cn("w-4 h-4", darkMode ? "text-orange-400" : "text-primary")} />
                            </div>
                        )}
                        <div>
                            <h1 className={cn(
                                "text-base font-bold leading-tight",
                                darkMode ? "text-white" : "text-zinc-900"
                            )}>{title}</h1>
                            {subtitle && (
                                <p className={cn(
                                    "text-xs",
                                    darkMode ? "text-gray-400" : "text-zinc-500"
                                )}>{subtitle}</p>
                            )}
                        </div>
                    </div>
                </div>
                {rightContent && (
                    <div className="flex items-center gap-2">
                        {rightContent}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MobilePageHeader;
